// ======================================
// Admin App Config — URLs auto-select based on REACT_APP_MODE
// Set REACT_APP_MODE=development or production in admin/.env
// ======================================

const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const MODE = isLocalhost ? 'development' : (process.env.REACT_APP_MODE || 'development');
const isProd = MODE === 'production';

// Backend API URL
export const BACKEND_URL = isProd
  ? (process.env.REACT_APP_PROD_BACKEND_URL || 'https://api.betanic.com')
  : (process.env.REACT_APP_DEV_BACKEND_URL || 'http://localhost:3009');

// Frontend Site URL
export const FRONTEND_URL = isProd
  ? (process.env.REACT_APP_PROD_FRONTEND_URL || 'https://betanic.com')
  : (process.env.REACT_APP_DEV_FRONTEND_URL || 'http://localhost:3000');

// Admin Panel URL (self)
export const ADMIN_URL = isProd
  ? (process.env.REACT_APP_PROD_ADMIN_URL || 'https://admin.betanic.com')
  : (process.env.REACT_APP_DEV_ADMIN_URL || 'http://localhost:3001');

export const appConfig = {
  baseURL: BACKEND_URL,    // backend API — used by all API calls
  frontendURL: FRONTEND_URL,   // main website
  adminURL: ADMIN_URL,      // this admin panel
  apiTimeout: 15000,
  defaultRole: 'user',
  isProd,
  MODE,
};

export default appConfig;
